<div>
  <app-central-task-detail [newTask]="true" [taskRaisedBy]="raisedBy$ | async" [sourceSite]="sourceSite$ | async" [orderDetails]="orderDetails">
  </app-central-task-detail>
</div>
